import { render, staticRenderFns } from "./SellersForm.vue?vue&type=template&id=4a1ab57c&scoped=true&"
import script from "./SellersForm.vue?vue&type=script&lang=js&"
export * from "./SellersForm.vue?vue&type=script&lang=js&"
import style0 from "./SellersForm.vue?vue&type=style&index=0&id=4a1ab57c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1ab57c",
  null
  
)

export default component.exports